import styled from "styled-components";
import {solease_gray, solease_red} from "../../constants/Colors";

const Heading = styled.p`
  font-family: EnzoOT, sans-serif;
  font-size: 24px;
  color: ${solease_gray};
`

const SubHeading = styled.p`
  font-family: EnzoOT, sans-serif;
  font-size: 20px;
  text-transform: uppercase;
  color: ${solease_gray};

  @media (min-width: 900px) {
    font-size: 24px;
  }
`

const Text = styled("p")<{ large?: boolean, small?: boolean }>`
  font-size: ${props => props.large ? '16px' : props.small ? '12px' : '14px'};
  line-height: 25px;
  white-space: pre-wrap;
  color: ${solease_gray};

  @media (min-width: 900px) {
    font-size: ${props => props.large ? '18px' : props.small ? '14px' : '16px'};
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 46px;
`

const StepWrapper = styled.div`

  @media (min-width: 900px) {
    width: 100%;
    max-width: 960px;
    padding: 84px 100px;
    margin: auto;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);
    border-radius: 20px;
  }
`

const ErrorText = styled(Text)`
  position: absolute;
  right: 0;
  bottom: 42px;
  font-size: 10px;
  color: ${solease_red};
  transition: all .3s;
`

export {
    Heading,
    SubHeading,
    Text,
    ButtonContainer,
    StepWrapper,
    ErrorText
}
